module.exports = __webpack_public_path__ + "img/et.et6182262.svg";